import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "VehicleServiceDashboardPage" */
	'pages/vehicle/VehicleServiceDashboardPage'));

export default [{ component, exact: true, path: '/vehicle_dashboard' }];